import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../navigators';
import {SuccessTemplate} from '../../components/templates/success';
import {PrimaryButton} from '../../components/buttons';
import {message} from '../../utils/messages';

type ScreenProps = NativeStackScreenProps<StackParamList, 'ResetSuccess'>;

export const ResetSuccessScreen = ({navigation}: ScreenProps) => {
  const handleOnOk = async () => {
    navigation.navigate('SignIn');
  };

  return (
    <SuccessTemplate
      title={message('reset-success-title')}
      summary={message('reset-success-summary')}>
      <PrimaryButton
        label={message('reset-success-button')}
        onPress={() => handleOnOk()}
      />
    </SuccessTemplate>
  );
};
